import { render, staticRenderFns } from "./TaskDevicePopup.vue?vue&type=template&id=35145821&scoped=true&"
import script from "./TaskDevicePopup.vue?vue&type=script&lang=js&"
export * from "./TaskDevicePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35145821",
  null
  
)

export default component.exports